import React, { Fragment, useState } from "react";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import Collapse from "@mui/material/Collapse";
import { Link } from "react-router-dom";
import "./style.css";

const menus = [
    {
        id: 1,
        title: "Home",
        link: "/home",
    },
    {
        id: 7,
        title: "Causes",
        link: "/causes",
    },
    {
        id: 37,
        title: "Events",
        link: "/events",
    },
    {
        id: 34,
        title: "Our Team",
        link: "/team",
        submenu: [
            {
                id: 11,
                title: "Our Team",
                link: "/team",
            },
            {
                id: 3454,
                title: "Our Founder",
                link: "/team-single/Liza-Hart",
            },
        ],
    },
    {
        id: 31,
        title: "About Us",
        link: "/about",
    },
    {
        id: 3222,
        title: "Contact Us",
        link: "/contact",
    },
];

const MobileMenu = () => {
    const [openId, setOpenId] = useState(0);
    const [menuActive, setMenuState] = useState(false);

    const ClickHandler = () => {
        window.scrollTo(10, 0);
        setMenuState(false);
    };

    return (
        <div>
            <div className={`mobileMenu ${menuActive ? "show" : ""}`}>
                <div className="menu-close">
                    <div className="clox" onClick={() => setMenuState(!menuActive)}>
                        <i className="ti-close"></i>
                    </div>
                </div>

                <ul className="responsivemenu">
                    {menus.map((item) => (
                        <ListItem
                            key={item.id}
                            className={item.id === openId ? "active" : ""}
                        >
                            {item.submenu ? (
                                <Fragment>
                                    <p onClick={() => setOpenId(item.id === openId ? 0 : item.id)}>
                                        {item.title}
                                        <i
                                            className={
                                                item.id === openId
                                                    ? "fa fa-angle-up"
                                                    : "fa fa-angle-down"
                                            }
                                        ></i>
                                    </p>

                                    <Collapse
                                        in={item.id === openId}
                                        timeout="auto"
                                        unmountOnExit
                                    >
                                        <List className="subMenu">
                                            {item.submenu.map((submenu) => (
                                                <ListItem key={submenu.id}>
                                                    <Link
                                                        onClick={ClickHandler}
                                                        className="active"
                                                        to={submenu.link}
                                                    >
                                                        {submenu.title}
                                                    </Link>
                                                </ListItem>
                                            ))}
                                        </List>
                                    </Collapse>
                                </Fragment>
                            ) : (
                                <Link
                                    className="active"
                                    to={item.link}
                                    onClick={ClickHandler}
                                >
                                    {item.title}
                                </Link>
                            )}
                        </ListItem>
                    ))}
                </ul>
            </div>

            <div className="showmenu" onClick={() => setMenuState(!menuActive)}>
                <button type="button" className="navbar-toggler open-btn">
                    <span className="icon-bar first-angle"></span>
                    <span className="icon-bar middle-angle"></span>
                    <span className="icon-bar last-angle"></span>
                </button>
            </div>
        </div>
    );
};

export default MobileMenu;
